import { render, staticRenderFns } from "./abandonDeviceManagement.vue?vue&type=template&id=613ea774&scoped=true&"
import script from "./abandonDeviceManagement.vue?vue&type=script&lang=js&"
export * from "./abandonDeviceManagement.vue?vue&type=script&lang=js&"
import style0 from "./abandonDeviceManagement.vue?vue&type=style&index=0&id=613ea774&prod&scoped=true&lang=css&"
import style1 from "./abandonDeviceManagement.vue?vue&type=style&index=1&id=613ea774&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "613ea774",
  null
  
)

export default component.exports